import { Link } from "react-router-dom";
import { currency, resolveImage } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Plus } from "lucide-react";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const discount = product.compare_at_price
    ? Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100)
    : null;

  return (
    <div
      data-testid={`product-card-${product.slug}`}
      className="group bg-white border border-[#e6e2d8] rounded-md overflow-hidden card-hover flex flex-col"
    >
      <Link to={`/product/${product.slug}`} className="block relative aspect-[4/5] overflow-hidden bg-[#efeadd]">
        {product.image_url && (
          <img
            src={resolveImage(product.image_url)}
            alt={product.name}
            className="w-full h-full object-cover image-zoom"
          />
        )}
        {discount && (
          <span className="absolute top-3 left-3 bg-[#c36a4f] text-white text-[10px] tracking-widest px-2 py-1 rounded-full font-medium">
            -{discount}%
          </span>
        )}
      </Link>
      <div className="p-5 flex-1 flex flex-col">
        <p className="overline mb-1">{product.category}</p>
        <Link to={`/product/${product.slug}`}>
          <h3 className="font-serif text-2xl text-[#1e392a] leading-tight hover:text-[#c36a4f] transition-colors">
            {product.name}
          </h3>
        </Link>
        <p className="mt-2 text-sm text-[#8a8d86] line-clamp-2 flex-1">
          {product.short_description}
        </p>
        <div className="mt-4 flex items-center justify-between">
          <div>
            <span className="font-serif text-2xl text-[#1e392a]">{currency(product.price)}</span>
            {product.compare_at_price && (
              <span className="ml-2 text-sm text-[#8a8d86] line-through">
                {currency(product.compare_at_price)}
              </span>
            )}
          </div>
          <button
            data-testid={`add-to-cart-${product.slug}`}
            onClick={() => addItem(product, 1)}
            className="h-10 w-10 rounded-full bg-[#1e392a] text-white flex items-center justify-center hover:bg-[#c36a4f] transition-colors"
            aria-label={`Add ${product.name} to cart`}
          >
            <Plus className="h-4 w-4" strokeWidth={2} />
          </button>
        </div>
      </div>
    </div>
  );
}
